import { render, staticRenderFns } from "./hqglLogisticsInventory.vue?vue&type=template&id=0cf681f7&scoped=true&"
import script from "./hqglLogisticsInventory.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf681f7",
  null
  
)

export default component.exports